import React, { useState } from 'react';
import { Table } from '../common';
import Paginator from '../common/tables/Paginator';
import PortOpeningRequestSiteToSiteOnPrem from '../../models/entities/PortOpeningRequestSiteToSiteOnPrem';
import ApprovalsS2SPORsTableRow from './ApprovalsS2SPORsTableRow';

interface ApprovalsS2SPORsTableProps {
    filteredS2SPORs: PortOpeningRequestSiteToSiteOnPrem[];
}

const ApprovalsS2SPORsTable = ({
    filteredS2SPORs,
}: ApprovalsS2SPORsTableProps) => {
    const [porsOnPage, setPorsOnPage] = useState<PortOpeningRequestSiteToSiteOnPrem[]>([]);
    return (
        <Table
            footer={
                <Paginator
                    data={filteredS2SPORs}
                    onPageChange={(pors: PortOpeningRequestSiteToSiteOnPrem[]) => {
                        setPorsOnPage(pors)
                    }}
                />
            }
        >
            <Table.Head>
                <Table.Head.Row>
                    <Table.Head.Cell>POR #</Table.Head.Cell>
                    <Table.Head.Cell className='em-u-text-align-center'>
                        Status
                    </Table.Head.Cell>
                    <Table.Head.Cell className='em-u-text-align-center'>Action</Table.Head.Cell>
                </Table.Head.Row>
            </Table.Head>
            <Table.Body>
                {porsOnPage.map((por: PortOpeningRequestSiteToSiteOnPrem) => {
                    return <ApprovalsS2SPORsTableRow
                        key={por.id}
                        por={por}
                    />;
                }
                )}
            </Table.Body>
        </Table>
    );
}

export default ApprovalsS2SPORsTable;